import type { ExperienceName } from '@atlassian/conversation-assistant-instrumentation/constants/experience-tracker';
import type { ExperienceTrackerAPI } from '@atlassian/conversation-assistant-instrumentation/main';

export const completeAifcActionExperience = (
	experienceTracker: ExperienceTrackerAPI,
	experienceName: typeof ExperienceName.AIFC_ALL_DATA_HANDLED | typeof ExperienceName.AIFC_MESSAGE,
	actionClassificationInvocationIds: ReadonlySet<string>,
	actionCompleteInvocationIds: ReadonlySet<string>,
	isBackendCreationRequest: boolean,
): void => {
	const actionClassificationCount = actionClassificationInvocationIds.size;
	const actionCompleteCount = actionCompleteInvocationIds.size;
	const attributes = {
		isBackendCreationRequest,
		actionClassificationCount,
		actionCompleteCount,
		actionClassificationInvocationIds: [...actionClassificationInvocationIds],
		actionCompleteInvocationIds: [...actionCompleteInvocationIds],
	};

	// Matches our condition for abortGenerateContentChildExperiences elsewhere, for callers that don't fallthrough
	// This gives us an explicit abort rather than a timeout
	if (actionClassificationCount > 0 && actionCompleteCount === 0) {
		experienceTracker.abort({
			name: experienceName,
			reason: 'stream_completed_without_action_complete',
			attributes,
		});
		return;
	}

	if (
		!isBackendCreationRequest || // Not all FE requests provide action_classification, so a single complete is sufficient
		(actionClassificationCount === actionCompleteCount &&
			[...actionClassificationInvocationIds].every((invocationId) =>
				actionCompleteInvocationIds.has(invocationId),
			))
	) {
		experienceTracker.succeed({ name: experienceName, attributes });
	} else {
		experienceTracker.fail({
			name: experienceName,
			attributes,
			error: new Error('Action completion invocation IDs did not match classifications'),
		});
	}
};
